import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.entries";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _get from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/get.js";
import _inherits from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import { LOGIN_TIMEOUT } from "./constant";
import { AtomError } from "./lib/error";
import Protocol from "./protocol";
var uniqueId = 1;
/**
 * QQSports JSBridge
 * 腾讯体育调用JSBridge
 * @class QQSportsBridge
 * @extends {Phone}
 */

var QQSportsBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(QQSportsBridge, _Protocol);

  var _super = _createSuper(QQSportsBridge);

  function QQSportsBridge() {
    var _this;

    _classCallCheck(this, QQSportsBridge);

    _this = _super.call(this);
    _this.name = 'QQSportsBridge';

    if (env.isQQSports) {
      // 默认处理,显示页面标题
      _this.setTitle(document.title);

      if (env.isIos) {
        // 默认处理,更快显示页面,调用失败时不抛异常
        _this.invoke('showWebContent').catch(function () {});
      }
    }

    return _this;
  }

  _createClass(QQSportsBridge, [{
    key: "invoke",
    value: function invoke() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };

      // 兼容直接invoke的场景，可直接调用内部抹平方法
      if (typeof this[api] === 'function') {
        return this[api](params, options);
      }

      return this.call(api, params, options);
    }
    /**
     * 真正调用Bridge
     * @param {String} api
     * @param {Object} params
     * @param {Object} options
     * @returns
     */

  }, {
    key: "call",
    value: function call() {
      var _this2 = this;

      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 5000
      };
      console.log("[QQSportsBridge] invoke ".concat(api, " params="), params);
      return new Promise(function (resolve, reject) {
        var timer;

        if (options.timeout > 0) {
          timer = setTimeout(function () {
            reject(new AtomError("[QQSportsBridge] invoke '".concat(api, "' timeout ").concat(options.timeout, "ms")));
          }, options.timeout);
        }

        _this2.callNative(api, params, function (result) {
          for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            others[_key - 1] = arguments[_key];
          }

          console.log("[QQSportsBridge] invoke ".concat(api, " callback="), result, others);
          clearTimeout(timer);

          if (!result && others.length > 0) {
            // 部分JSAPI，没有统一在第一参数返回
            resolve(others);
          } else {
            resolve(result);
          }
        });
      });
    }
  }, {
    key: "callNative",
    value: function callNative() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var callbackId = "qqsports_".concat(uniqueId, "_").concat(new Date().getTime());
      uniqueId += 1;

      if (typeof callback === 'function') {
        window[callbackId] = callback;
      }

      var nativeParams = _objectSpread(_objectSpread({}, params), {}, {
        callbackName: callbackId
      });

      if (env.isAndroid) {
        // 安卓会有两种调用方式，6.0.x 之后用 callNativeMethod，不再支持 alert
        if (window.QQSportsBridge && typeof window.QQSportsBridge.callNativeMethod === 'function') {
          window.QQSportsBridge.callNativeMethod(location.href, "js_".concat(api, "(").concat(JSON.stringify(nativeParams), ")"));
        } else {
          alert("js_".concat(api, "(").concat(JSON.stringify(nativeParams), ")"));
        }
      } else {
        var iosParams = Object.entries(nativeParams).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              val = _ref2[1];

          return "".concat(key, "=").concat(encodeURIComponent(_typeof(val) === 'object' ? JSON.stringify(val) : val));
        });
        var schemeUrl = "".concat(env.isIpad ? 'http' : 'https', "://sports.qq.com/jsBridge/").concat(api, "?").concat(iosParams.join('&'));
        var proxyFrame = document.createElement('iframe');
        proxyFrame.style.cssText = 'width:1;height:1px;border:none;position:fixed;top:0;left:0;'; // 使可能存在的 html2canvas 忽略这个 iframe

        proxyFrame.setAttribute('data-html2canvas-ignore', 'true');

        proxyFrame.onload = function () {
          this.remove();
        };

        proxyFrame.src = schemeUrl;
        document.body.appendChild(proxyFrame);
      }
    }
  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      return this.call('getDeviceInfo');
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      return _get(_getPrototypeOf(QQSportsBridge.prototype), "getMainUserInfo", this).call(this, true);
    }
    /**
     * openLogin
     * 如果已登录调用会返回结果，不显示登录弹窗
     */

  }, {
    key: "openLogin",
    value: function openLogin() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$type = _ref3.type,
          type = _ref3$type === void 0 ? '' : _ref3$type;

      var isLogin = cookie.get('main_login');

      if (isLogin) {
        // 登录状态下，调用switchLogin
        return this.switchLogin(type);
      } // 成功后能正常回调


      return this.call('login', {}, {
        timeout: LOGIN_TIMEOUT
      }).then(function (isLogin) {
        if (!isLogin) {
          throw new AtomError('登录失败', -1);
        }

        if (env.isIos) {
          // 刷新页面,避免cookie不更新问题
          location.reload();
        }

        return {
          isLogin: isLogin
        };
      });
    }
    /**
     * switchLogin
     * @parma {String} type - 账号类型`
     */

  }, {
    key: "switchLogin",
    value: function switchLogin() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 慎用，只有登录成功才有回调
      // 旧版本存在，成功后仍无回调，现在用timeout去更新登录态
      return this.call('switchLogin', {
        type: type
      }, {
        timeout: LOGIN_TIMEOUT
      }).then(function () {
        if (env.isIos) {
          // 刷新页面,避免cookie不更新问题
          location.reload();
        }

        return true;
      });
    }
    /**
     * switchLogin
     * @parma {String} type - 账号类型`
     */

  }, {
    key: "switchLoginState",
    value: function switchLoginState() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // 慎用，只有登录成功才有回调
      return this.switchLogin(type);
    }
    /*
     * 打开新页面
     * @param {String} url - 页面链接
     */

  }, {
    key: "openUrl",
    value: function openUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        title: document.title
      };

      if (!url.match(/^https?:\/\//)) {
        return this.openView(url);
      }

      var params = {
        type: 1
      };

      if (env.isIos) {
        params.url = url;
        params.title = options.title || '';
      } else {
        params.param = {
          url: url,
          title: options.title || ''
        };
      }

      return this.call(env.isIos ? 'open' : 'openNativePage', params);
    }
    /*
     * 跳转伪协议
     * @param {String} url - schema链接
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.call(env.isIos ? 'open' : 'openNativePage', {
        type: 2,
        url: url
      });
    }
    /*
     * 保存图片
     * @param {String} url - 仅支持在线图片地址
     */

  }, {
    key: "saveImage",
    value: function saveImage(_ref4) {
      var _ref4$url = _ref4.url,
          url = _ref4$url === void 0 ? '' : _ref4$url;

      if (!url || !url.match(/^https?:\/\//)) {
        throw new AtomError('当前环境仅支持下载在线图片', -1001);
      }

      return this.call('saveImage', {
        image: url
      });
    }
    /*
     * 设置页面标题
     * @param {String} title - 标题
     */

  }, {
    key: "setTitle",
    value: function setTitle() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.call('setTitle', {
        title: title
      });
    }
    /**
     * 指定base64图片分享渠道
     * @param {Object} params
     * @param {string} params.type - 分享渠道
     * @param {string} params.imgbase64 - 分享图片的base64
     * @example shareTo({ type: 'weixin', imgbase64: 'XXX' })
     */

  }, {
    key: "shareTo",
    value: function shareTo(_ref5) {
      var type = _ref5.type,
          imgbase64 = _ref5.imgbase64;
      var regex = /^data:image\/\w+;base64,/;

      if (!imgbase64 || !imgbase64.match(regex)) {
        throw new AtomError('shareTo仅支持分享base64图片', -1001);
      }

      var shareTypeMap = {
        qzone: [2],
        weixin: [3],
        wxmoments: [4],
        weibo: [5],
        qq: [6]
      };
      var shareBtnList = shareTypeMap[type] || [2, 3, 4, 5, 6];
      return this.call('setShareByBase64', {
        shareBtnList: shareBtnList,
        // 如果length为1，则直接跳到朋友圈/微信/空间，如果length>1则展示分享面板
        base64: imgbase64.replace(regex, '') // ios不能带data的头，必须是纯洁的base64

      });
    }
  }]);

  return QQSportsBridge;
}(Protocol);

export default new QQSportsBridge();